import { useMediaQuery, useTheme } from '@mui/material';

export interface ResponsiveFlags {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

/**
 * Single source of truth for viewport regime detection.
 * Mobile: <900px. Tablet: 900–1199px. Desktop: ≥1200px.
 * See docs/kb/ui/responsive-regimes.md.
 */
export function useResponsive(): ResponsiveFlags {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  return { isMobile, isTablet, isDesktop };
}
